import React from 'react';
import a_Product_Data from './a_Product_Data';


const View_Favorites = ({ favorites, removeFromFavorites }) => {
// Function to get product information by index
const getProductInfo = (index) => {
    if (index >= 0 && index < a_Product_Data.length) {
      return {
        title: a_Product_Data[index][0],
        price: a_Product_Data[index][1],
        category: a_Product_Data[index][2],
        brand: a_Product_Data[index][3],
        status: a_Product_Data[index][4],
      };
    }
    return null;
  };
 
  // Check if cart is empty
  if (favorites.length === 0) {
    return <div>Favorite Page is empty. There are no products.</div>;
  }

  return (
    <>
    <div className='container p-0 m-0'>      
    <div class="row g-2">     
      {favorites.map((index) => {
        const productInfo = getProductInfo(index);
        return (
          <div key={index} className='col-6 col-md-4 col-lg-3 favorite-card'>
          <div className='rounded border p-2 position-relative overflow-hidden '>
            <img src="/img/product/img1_1.png" style={{minWidth:'150px'}} className='img-fluid' alt={productInfo.title} />             
            <button className='position-absolute favorite-card-close' onClick={() => removeFromFavorites(index)}>x</button>
          </div>
          </div>
        );
      })}
    </div>
    </div>


    </>
  );
};

export default View_Favorites;